window.constants = {
    // Need to update for hk
    sampleProducts: [
        // 35830377414808,
        // 33886082203781,
        // 35831911514264,
        // 36308628537496
    ],

    // I don't think this is needed anymore
    // sampleHandles: [
    //     "miss-dior-sample-1ml",
    //     "sauvage-parfum-sample-1ml",
    //     "capture-totale-sample-1ml",
    //     "lip-glow-sample-1ml",
    // ],

    giftMessage: 33064833351813, // https://shop-dior-hk.myshopify.com/admin/products/4733719281797/variants/33064833351813
    giftMessageMaison: 33064833351813, //34271141789829, // https://shop-dior-hk.myshopify.com/admin/products/5074794315909/variants/34271141789829
    noMcdCard: 35262925701272, // need to remove/clean // https://shop-dior-hk.myshopify.com/admin/products/5486007255192/variants/35262925701272
    browCard: 35502233419928, // https://shop-dior-hk.myshopify.com/admin/products/5557203402904/variants/35502233419928

    samples: [
        { // 0 Sample C199600544 PREST MHR ADV SPL BUBLE 1ML INT20 | 1Oct - 31Dec
            code: "C199600544", // https://shop-dior-hk.myshopify.com/admin/products/5654970007704/variants/35830377414808
            id: 35830377414808, // 
        },
        { // 1 Sample C108370010 DSK FORV FL SKIN GLOW POS SPL SACH 1ML 1N AS20
            code: "C108370010", // https://shop-dior-hk.myshopify.com/admin/products/5655268163736/variants/35831843586200
            id: 33886082203781, // 
        },
        { // 2 Sample C199600417 | J'adore Eau de Parfum & Body Milk Sampling Kit | Duration 26 Oct- 31 Dec | By inscoder
            code: "C199600417", // https://shop-dior-hk.myshopify.com/admin/products/5906528043160/variants/36805625217176
            id: 36805625217176, // 
        },
        // { // 2 Sample C199600361 MD BB SPL SOFIST - SPL BODY MILK INT19 | 1Sep - 25 Oct
        //     code: "C199600361", // https://shop-dior-hk.myshopify.com/admin/products/5655277371544/variants/35831911514264
        //     id: 35831911514264, // 
        // },
        { // 3
            code: "HKF916831000CRMA",
            id: 36308628537496, // 4
        },        
        // { // 4 Sample C199600392 C / TOT SER POS SPL SACH 1.5 ML INT20
        //     code: "C199600392", // https://shop-dior-hk.myshopify.com/admin/products/5074828263557/variants/34271258607749
        //     id: 34271258607749, // 
        // },
    ],
    gwpArray: [

        35502233419928,
        36308628537496,
        35830377414808, // 1Oct - 31Dec
        // 35831911514264, // 1Sep - 25 Oct
        33886082203781,
        35832586371224,
        36480542736536,
        36480589070488,
        36480914555032,
        36480629768344,
        36480822476952,
        36480874217624,
        36480914555032,
        36480709591192,
        36480679510168,
        36480732659864,
        36020333478040,
        35969112375448, // BOCOM | 1 Sep - 31 Dec
        
        36805625217176, // sample product on any purchase | Duration 26 Oct- 31 Dec | By inscoder
        36480776601752, // GWP Upon purchase of any Xmas Staycation Items | Duration 26 Oct – 30 Nov | By inscoder
        33886040686725, // JAD EDP SPL MINIA FB 5ML INT18 | Duration 26 Oct - 31 Dec | By inscoder
        33801133654149, // JAD EDP SPL MINIA FB 5ML INT18 | Duration 26 Oct - 31 Dec | By inscoder
        // 36961858453656, // HK ePop up Xmas Invitation Card | Duration 1 Nov - 15 Dec | By inscoder
        36480822476952, // GOLDENIGHTS | Duration 23 oct - 15 Nov | By inscoder 

        // Promocodes to view under "GIFTS & SAMPLES" in mini-cart | By inscoder
        // MCDHOME | 16 - 31 Dec
        34919577223320,
        34919516209304,
        34919541866648,

        // ILOVEXMAS | 11 Nov - 24 Dec
        36807982383256,
        36807849214104,
        36807782695064,

        // HOLIDAY | 1 - 31 Dec
        36807370113176,
        36807474151576,

        // XMASCARE | 1 - 24 Dec
        36906372661400,
        36807718600856,
        36480679510168,

        // LOVEROUGE | 15 Oct - 31 Nov
        36808103035032,
        33064825421957,
        36807782695064,

        // CT2020 | 26 Oct - 31 Nov
        36906372661400,
        36808134033560,
        36480679510168,

        // GOLDENIGHTS | 23 Oct - 15 Nov (exists above)
        36480874217624,

    
        34271263326341, // CTCOSMO | 23 Sep - 31 Oct https://shop-dior-hk.myshopify.com/admin/products/5074829475973/variants/34271263326341
        35602070995096, // CTCOSMO | 23 Sep - 31 Oct | https://shop-dior-hk.myshopify.com/admin/products/5590278799512/variants/35602070995096
        36363130339480, // CTCOSMO | 23 Sep - 31 Oct | https://shop-dior-hk.myshopify.com/admin/products/5787590295704/variants/36363130339480
    
    ],
    gwp: [
         { // 0 - GWP	F648119000	Prestige Luxury Sample Kit (serum 5ml + cream 5ml)(worth value $664) Upon puchase Prestige Virtual Set (SCSET01 & SCSET02)
            name: "F648119000", // https://shop-dior-hk.myshopify.com/admin/products/5819315912856/variants/36480542736536
            id: 36480542736536,
            enabled: true,
            min: false,
            maxQty: 1,
            code: false
        },  


        { // 1 - GWP	C400070653	LIFE OFFER AS1H20	300	Purchase 1500 or above 
            name: "C400070653", // https://shop-dior-hk.myshopify.com/admin/products/5655371546776/variants/35832586371224 Purchase 1500 or above
            id: 35832586371224,
            enabled: true,
            min: 150000,
            maxQty: 1,
            code: false
        },


        // 522-dior-hk-discount-codes
        // 2 - LVMH800
        { // Amount $800 or above & input promotion code LVMH800 to receive C400070638
            name: "C400070638", // https://shop-dior-hk.myshopify.com/admin/products/5739119411352/variants/36232751153304
            id: 36232751153304,
            enabled: true,
            min: 80000,
            maxQty: 1,
            code: "LVMH800"
        },
        // 3 - LVMHFASHION
        { // Purchase any of the following products & input promotion code LVMHFASHION to receive C400000742C013673010
            // Product 1 https://shop-dior-hk.myshopify.com/admin/products/5739070095512
            // Product 2 https://shop-dior-hk.myshopify.com/admin/products/4933362221189
            name: "C400000742C013673010", // https://shop-dior-hk.myshopify.com/admin/products/5739113382040/variants/36232771862680
            id: 36232771862680,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "LVMHFASHION"
        },


        // 4 - DM CUSTOMER CODE GWP
        { 
            name: "C400000580", // https://shop-dior-hk.myshopify.com/admin/products/5699871899800/variants/36020333478040
            id: 36020333478040,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "DM"
        },
        // 5 - CTCOSMO CODE GWP 1 | 23 Sep - 31 Oct
        { 
            name: "C199600405", // https://shop-dior-hk.myshopify.com/admin/products/5074829475973/variants/34271263326341
            id: 34271263326341,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "CTCOSMO"
        },   
        // 6 - CTCOSMO CODE GWP 2 | 23 Sep - 31 Oct
        { 
            name: "C199600404", // https://shop-dior-hk.myshopify.com/admin/products/5590278799512/variants/35602070995096
            id: 35602070995096,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "CTCOSMO"
        },  
        // 7 - CTCOSMO CODE GWP 3 | 23 Sep - 31 Oct
        { 
            name: "C800200092", // https://shop-dior-hk.myshopify.com/admin/products/5787590295704/variants/36363130339480
            id: 36363130339480,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "CTCOSMO"
        },      
        
        

        { // 8 - GWP	C199600427	Dreamskin 7ml (worth value $184) Upon purchase Capture Total Virtual Set (SCSET03)
            name: "C199600427", // https://shop-dior-hk.myshopify.com/admin/products/5819334688920/variants/36480589070488
            id: 36480589070488,
            enabled: true,
            min: false,
            maxQty: 1,
            code: false
        }, 
        
        

        
        // 9 - ROSE CODE GWP 1
        { 
            name: "C400000758", // https://shop-dior-hk.myshopify.com/admin/products/5819537555608/variants/36480914555032
            id: 36480914555032,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "ROSE"
        },   
        // 10 - ROSE CODE GWP 2
        { 
            name: "F167057000", // https://shop-dior-hk.myshopify.com/admin/products/5819352088728/variants/36480629768344
            id: 36480629768344,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "ROSE"
        },  
        // 11 - ROSE CODE GWP 3
        { 
            name: "F185011000", // https://shop-dior-hk.myshopify.com/admin/products/5819380793496/variants/36480679510168
            id: 36480679510168,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "ROSE"
        }, 


        // 12 - XMAS800 CODE GWP
        { 
            name: "HKC102673999A", // https://shop-dior-hk.myshopify.com/admin/products/5819472806040/variants/36480822476952
            id: 36480822476952,
            enabled: true,
            min: 80000,
            maxQty: 1,
            code: "XMAS800"
        },   

        // 13 - GOLDENIGHTS CODE GWP
        { 
            name: "HKC800200091A", // https://shop-dior-hk.myshopify.com/admin/products/5819509899416/variants/36480874217624
            id: 36480874217624,
            enabled: true,
            min: 80000,
            maxQty: 1,
            code: "GOLDENIGHTS"
        },   
        
        
        // 14 - PRESTIGE CODE GWP 1
        { 
            name: "C400000758", // https://shop-dior-hk.myshopify.com/admin/products/5819537555608/variants/36480914555032
            id: 36480914555032,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "PRESTIGE"
        },   
        // 15 - PRESTIGE CODE GWP 2
        { 
            name: "F167038000", // https://shop-dior-hk.myshopify.com/admin/products/5819398324376/variants/36480709591192
            id: 36480709591192,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "PRESTIGE"
        },  
        // 16 - PRESTIGE CODE GWP 3
        { 
            name: "F185011000", // https://shop-dior-hk.myshopify.com/admin/products/5819380793496/variants/36480679510168
            id: 36480679510168,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "PRESTIGE"
        },   
        
        

        // 17 - LOVEROSE CODE GWP 1
        { 
            name: "C400000758", // https://shop-dior-hk.myshopify.com/admin/products/5819537555608/variants/36480914555032
            id: 36480914555032,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "LOVEROSE"
        },   
        // 18 - LOVEROSE CODE GWP 2
        { 
            name: "C199600250", // https://shop-dior-hk.myshopify.com/admin/products/5819398324376/variants/36480709591192
            id: 36480732659864,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "LOVEROSE"
        },  
        // 19 - LOVEROSE CODE GWP 3
        { 
            name: "F185011000", // https://shop-dior-hk.myshopify.com/admin/products/5819380793496/variants/36480679510168
            id: 36480679510168,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "LOVEROSE"
        },   
        // 20 - BOCOM | 1 Sep - 31 Dec
        { 
            name: "HKC800200088A", // https://shop-dior-hk.myshopify.com/admin/products/5687350526104/variants/35969112375448
            id: 35969112375448,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "BOCOM"
        },

        // 21 - DSK FORV FL SPL MIN LUXE 5ML 1N INT19 | Duration 26 OCT - 30 Nov | By inscoder
        { 
            name: "C104500010", // https://shop-dior-hk.myshopify.com/admin/products/5819442495640/variants/36480776601752
            id: 36480776601752,
            enabled: true,
            min: false,
            maxQty: 1,
            code: false
        },
        // 22 - JAD EDP SPL MINIA FB 5ML INT18 | Duration 26 Oct - 31 Dec | By inscoder
        { 
            name: "C199600072", // https://shop-dior-hk.myshopify.com/admin/products/4963456647301/variants/33886040686725
            id: 33886040686725,
            enabled: true,
            min: false,
            maxQty: 1,
            code: false
        },
        // 23 - JAD EDP SPL MINIA FB 5ML INT18 | Duration 26 Oct - 31 Dec | By inscoder
        { 
            name: "C400000439", // https://shop-dior-hk.myshopify.com/admin/products/4960618152069/variants/33801133654149
            id: 33801133654149,
            enabled: true,
            min: false,
            maxQty: 1,
            code: false
        },
        // // 23 - HK ePop up Xmas Invitation Card | Duration 1 Nov - 15 Dec | By inscoder
        // { 
        //     name: "HKXMAS202011", // https://shop-dior-hk.myshopify.com/admin/products/5950562435224/variants/36961858453656
        //     id: 36961858453656,
        //     enabled: true,
        //     min: false,
        //     maxQty: 1,
        //     code: false
        // },

        // 24 - // promocode MCDHOME 1 | Duration 16 - 31 Dec | By inscoder
        { 
            name: "C199600291", // https://shop-dior-hk.myshopify.com/admin/products/5390955413656/variants/34919577223320
            id: 34919577223320,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "MCDHOME"
        },
        // 25 - // promocode MCDHOME 2 | Duration 16 - 31 Dec | By inscoder
        { 
            name: "C199600195", // https://shop-dior-hk.myshopify.com/admin/products/5390934278296/variants/34919516209304
            id: 34919516209304,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "MCDHOME"
        },
        // 26 - // promocode MCDHOME 3 | Duration 16 - 31 Dec | By inscoder
        { 
            name: "C199600191", // https://shop-dior-hk.myshopify.com/admin/products/5390942503064/variants/34919541866648
            id: 34919541866648,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "MCDHOME"
        },

        // 27 - // promocode HOLIDAY 1 | Duration 1 Dec - 31 Dec | By inscoder
        { 
            name: "C800300111", // https://shop-dior-hk.myshopify.com/admin/products/5907118096536/variants/36807370113176
            id: 36807370113176,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "HOLIDAY"
        },
        // 28 - // promocode HOLIDAY 2 | Duration 1 Dec - 31 Dec | By inscoder
        { 
            name: "C400000829", // https://shop-dior-hk.myshopify.com/admin/products/5907155714200/variants/36807474151576
            id: 36807474151576,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "HOLIDAY"
        },

        // 29 - // promocode ILOVEXMAS 1 | Duration 11 Nov - 24 Dec | By inscoder
        { 
            name: "C800200090", // https://shop-dior-hk.myshopify.com/admin/products/5907395477656/variants/36807982383256
            id: 36807982383256,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "ILOVEXMAS"
        },
        // 30 - // promocode ILOVEXMAS 2 | Duration 11 Nov - 24 Dec | By inscoder
        { 
            name: "C105600001", // https://shop-dior-hk.myshopify.com/admin/products/5907332202648/variants/36807849214104
            id: 36807849214104,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "ILOVEXMAS"
        },
        // 31 - // promocode ILOVEXMAS 3 | Duration 11 Nov - 24 Dec | By inscoder (conflicter with LOVEROUGE 3)
        { 
            name: "C104500020", // https://shop-dior-hk.myshopify.com/admin/products/5907294093464/variants/36807782695064
            id: 36807782695064,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "ILOVEXMAS"
        },

        // 32 - // promocode LOVEROUGE 1 | Duration 15 Oct - 31 Nov | By inscoder
        { 
            name: "C800200091", // https://shop-dior-hk.myshopify.com/admin/products/5907438731416/variants/36808103035032
            id: 36808103035032,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "LOVEROUGE"
        },
        // 33 - // promocode LOVEROUGE 2 | Duration 15 Oct - 31 Nov | By inscoder
        { 
            name: "C199600436", // https://shop-dior-hk.myshopify.com/admin/products/4733717282949/variants/33064825421957
            id: 33064825421957,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "LOVEROUGE"
        },
        // 34 - // promocode LOVEROUGE 3 | Duration 15 Oct - 31 Nov | By inscoder (conflicter with ILOVEXMAS 3)
        { 
            name: "C104500020", // https://shop-dior-hk.myshopify.com/admin/products/5907294093464/variants/36807782695064
            id: 36807782695064,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "LOVEROUGE"
        },

        // 35 - // promocode XMASCARE 1 | Duration 1 Dec - 24 Dec | By inscoder (conflicter with CT2020 1)
        { 
            name: "C800200089", // https://shop-dior-hk.myshopify.com/admin/products/5936158900376/variants/36906372661400
            id: 36906372661400,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "XMASCARE"
        },
        // 36 - // promocode XMASCARE 2 | Duration 1 Dec - 24 Dec | By inscoder
        { 
            name: "F167058000", // https://shop-dior-hk.myshopify.com/admin/products/5907267289240/variants/36807718600856
            id: 36807718600856,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "XMASCARE"
        },
        // 37 - // promocode XMASCARE 3 | Duration 1 Dec - 24 Dec | By inscoder (conflicter with CT2020 3)
        { 
            name: "F185011000", // https://shop-dior-hk.myshopify.com/admin/products/5819380793496/variants/36480679510168
            id: 36480679510168,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "XMASCARE"
        },

        // 38 - // promocode CT2020 1 | Duration 26 Oct - 31 Nov | By inscoder (conflicter with XMASCARE 1)
        { 
            name: "C800200089", // https://shop-dior-hk.myshopify.com/admin/products/5936158900376/variants/36906372661400
            id: 36906372661400,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "CT2020"
        },
        // 39 - // promocode CT2020 2 | Duration 26 Oct - 31 Nov | By inscoder
        { 
            name: "F185100000", // https://shop-dior-hk.myshopify.com/admin/products/5907451543704/variants/36808134033560
            id: 36808134033560,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "CT2020"
        },
        // 40 - // promocode CT2020 3 | Duration 26 Oct - 31 Nov | By inscoder (conflicter with XMASCARE 3)
        { 
            name: "F185011000", // https://shop-dior-hk.myshopify.com/admin/products/5819380793496/variants/36480679510168
            id: 36480679510168,
            enabled: true,
            min: false,
            maxQty: 1,
            code: "CT2020"
        },        

    ],
    engraveId: 31875596058705,
    idVariantMap: {
        // VaraintID: Product ID
        "35502233419928": 5557203402904,
        "36308628537496": 5772358779032,
        "35830377414808": 5654970007704, // 1Oct - 31Dec
        // "35831911514264": 5655277371544, // 1Sep - 25 Oct
        "33886082203781": 4960637812869,
        "35832586371224": 5655371546776,
        "36480542736536": 5819315912856,
        "36480589070488": 5819334688920,
        "36480914555032": 5819537555608,
        "36480629768344": 5819352088728,
        "36480822476952": 5819472806040,
        "36480874217624": 5819509899416,
        "36480914555032": 5819537555608,
        "36480709591192": 5819398324376,
        "36480679510168": 5819380793496,
        "36480732659864": 5819411988632,
        "35969112375448": 5687350526104, // BOCOM | 1 Sep - 31 Dec

        "36805625217176": 5906528043160, // Sample C199600417 | J'adore Eau de Parfum & Body Milk Sampling Kit | Duration 26 Oct- 31 Dec | By inscoder
        "36480776601752": 5819442495640, // DSK FORV FL SPL MIN LUXE 5ML 1N INT19 | Duration 26 OCT - 30 Nov | By inscoder
        "33886040686725": 4963456647301, // JAD EDP SPL MINIA FB 5ML INT18 | Duration 26 Oct - 31 Dec | By inscoder
        "33801133654149": 4960618152069, // JAD EDP SPL MINIA FB 5ML INT18 | Duration 26 Oct - 31 Dec | By inscoder
        // "36961858453656": 5950562435224, // HK ePop up Xmas Invitation Card | Duration 1 Nov - 15 Dec | By inscoder
        // "36480822476952": 5819472806040, // GOLDENIGHTS | Duration 23 oct - 15 Nov | By inscoder [already exists at line 395]

        // Promocodes to view under "GIFTS & SAMPLES" in mini-cart | By inscoder
        // MCDHOME | 16 - 31 Dec
        "34919577223320": 5390955413656,
        "34919516209304": 5390934278296,
        "34919541866648": 5390942503064,

        // ILOVEXMAS | 11 Nov - 24 Dec
        "36807982383256": 5907395477656,
        "36807849214104": 5907332202648,
        "36807782695064": 5907294093464,

        // HOLIDAY | 1 - 31 Dec
        "36807370113176": 5907118096536,
        "36807474151576": 5907155714200,

        // XMASCARE | 1 - 24 Dec
        "36906372661400": 5936158900376,
        "36807718600856": 5907267289240,
        "36480679510168": 5819380793496,

        // LOVEROUGE | 15 Oct - 31 Nov
        "36808103035032": 5907438731416,
        "33064825421957": 4733717282949,
        "36807782695064": 5907294093464,

        // CT2020 | 26 Oct - 31 Nov
        "36906372661400": 5936158900376,
        "36808134033560": 5907451543704,
        "36480679510168": 5819380793496,

        // GOLDENIGHTS | 23 Oct - 15 Nov (exists above)
        "36480874217624": 5819509899416,

        // XMAS800 | 23 Oct - 15 Nov (exists above)

        // Promocode CTCOSMO | 23 Sep - 31 Oct
        "34271263326341": 5074829475973, // https://shop-dior-hk.myshopify.com/admin/products/5074829475973/variants/34271263326341  
        "35602070995096": 5590278799512, // https://shop-dior-hk.myshopify.com/admin/products/5590278799512/variants/35602070995096
        "36363130339480": 5787590295704, // https://shop-dior-hk.myshopify.com/admin/products/5787590295704/variants/36363130339480 
        
    },
    // BeautyEx coupon code
    collectionEligibleIds: [
        33693569679493,
        33693569745029,
        33693570695301,
        33693571416197,
        33693572726917,
        33693572169861,
        33064825979013,
        35833530646680
    ],
    collectionIds: [
        35602125815960 
    ],

    // GOLDENIGHTS coupon code eligible product IDs | 23 Oct - 15 Nov
    goldenightsEligibleIds: [
        36909018611864,
        36909018841240,
        36909116784792,
        36908997050520,
        36908997443736,
        36908996526232
    ]
};